import React from 'react'
import PropTypes from "prop-types";
import CheckoutModal from "./CheckoutModal";
import Checkout2FAModalProvider from "./Provider";

const CheckoutModalContainer = (props) => {
    return (<Checkout2FAModalProvider {...props}>
        <CheckoutModal />
    </Checkout2FAModalProvider>)
}

CheckoutModalContainer.propTypes = {
    propsOrderId: PropTypes.string,
    propsStatus: PropTypes.string,
    propsServiceName: PropTypes.string,
    typeToken: PropTypes.string
}

export default CheckoutModalContainer
